import styled from 'styled-components';
import * as variables from './../../assets/css/variables';

export const Footing = styled.footer`
  background-color: ${variables.COLOR_BLUE};
  padding: 1.5714285714285714rem ${variables.SPACING_DESKTOP} 0.375rem ${variables.SPACING_DESKTOP};
  text-align: left;
  color: #FFF;
  
  img {
    margin-bottom: 2.982142857142857rem;
    width: 12.856428571428571rem;
  }
  
  p {
    font-size: 1rem;
    font-weight: lighter;
    text-align: end;
    text-transform: uppercase;
    margin: 0;
    padding: 0;
  }
  
  @media(max-width: ${variables.TABLET}) {
      padding: 1.5714285714285714rem ${variables.SPACING} 0.375rem ${variables.SPACING};
      
      img {
        margin-bottom: 2.982142857142857rem;
        width: 5.405rem;
      }
      
      p {
          font-size: 0.7142857142857143rem;
      }
  }
`;

export const Container = styled.div`
    max-width: ${variables.MAX_WIDTH};
    margin: 0 auto;
`;